export default "__VITE_ASSET__NKHgMxFB__"